<!--
 * @Author: your name
 * @Date: 2020-04-29 17:20:57
 * @LastEditTime: 2020-04-30 15:43:07
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \zlonmarinesite\src\components\contentcoms\newscontentcoms\newscontent.vue
 -->
<template>
  <div>
    <newsbanner></newsbanner>
    <!-- <div class="div-img-top1 body-width divcss5">
      <div class="font_zh">
        {{$t("news.newsinfomation")}}
      </div>
      <div class="font_en font_en_top">
        NEWS INFORMATION
      </div>
    </div> -->
    <div class="row body-width divcss5">
      <!-- <news1></news1> -->
      <component :is="currenttable" ref="cargoholdall"></component>
      <upanddown
        :id="id"
        :maxid="maxid"
        :up="up"
        :down="down"
        :updown="updown"
        :downnew="downnew"
      ></upanddown>
    </div>
  </div>
</template>

<script>
import newsbanner from "@/components/contentcoms/newscontentcoms/newsbanner";
import news1 from "@/components/contentcoms/news2019/news1";
import news2 from "@/components/contentcoms/news2020/news2";
import news3 from "@/components/contentcoms/news2020/news3";
import news4 from "@/components/contentcoms/news2020/news4";
import news5 from "@/components/contentcoms/news2020/news5";
import news6 from "@/components/contentcoms/news2020/news6";
import news7 from "@/components/contentcoms/news2020/news7";
import news8 from "@/components/contentcoms/news2020/news8";
import news9 from "@/components/contentcoms/news2020/news9";
import news10 from "@/components/contentcoms/news2020/news10";
import news11 from "@/components/contentcoms/news2020/news11";
import news12 from "@/components/contentcoms/news2020/news12";
import news13 from "@/components/contentcoms/news2020/news13";
import news14 from "@/components/contentcoms/news2020/news14";
import news15 from "@/components/contentcoms/news2020/news15";
import news16 from "@/components/contentcoms/news2020/news16";
import news17 from "@/components/contentcoms/news2020/news17";
import news18 from "@/components/contentcoms/news2020/news18";
import news19 from "@/components/contentcoms/news2020/news19";
import news20 from "@/components/contentcoms/news2020/news20";
import news21 from "@/components/contentcoms/news2020/news21";
import news22 from "@/components/contentcoms/news2020/news22";
import news23 from "@/components/contentcoms/news2021/news23";
import news24 from "@/components/contentcoms/news2021/news24";
import news25 from "@/components/contentcoms/news2021/news25";
import news26 from "@/components/contentcoms/news2022/news26";
import news27 from "@/components/contentcoms/news2023/news27";
import news28 from "@/components/contentcoms/news2024/news28";
import news29 from "@/components/contentcoms/news2024/news29";
import upanddown from "@/components/commoncoms/upanddown";
export default {
  data() {
    return {
      currenttable: "",
      up: false,
      down: false,
      updown: "",
      downnew: "",
      maxid: 1,
      id: 1,
    };
  },
  name: "newscontent",
  components: {
    news1,
    news2,
    news3,
    news4,
    news5,
    news6,
    news7,
    news8,
    news9,
    news10,
    news11,
    news12,
    news13,
    news14,
    news15,
    news16,
    news17,
    news18,
    news19,
    news20,
    news21,
    news22,
    news23,
    news24,
    news25,
    news26,
    news27,
    news28,
    news29,
    newsbanner,
    upanddown,
  },
  mounted() {
    this.currenttable = this.$route.query.news;
    this.up = this.$route.query.up;
    this.down = this.$route.query.down;
    this.updown = this.$route.query.updown;
    this.downnew = this.$route.query.downnew;
    this.maxid = this.$route.query.maxid;
    this.id = this.$route.query.id;
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/newscontentcoms/Oldnewscontent.vue